import { render, staticRenderFns } from "./InquiriesPage.vue?vue&type=template&id=0cbabf66&scoped=true&"
import script from "./InquiriesPage.vue?vue&type=script&lang=js&"
export * from "./InquiriesPage.vue?vue&type=script&lang=js&"
import style0 from "./InquiriesPage.vue?vue&type=style&index=0&id=0cbabf66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbabf66",
  null
  
)

export default component.exports